module.exports = __webpack_public_path__ + "static/media/finland-flag.05612e44.png";